// data/internal/useSaveController.ts
import { useState, useCallback } from "react";

export function useSaveController<T>(
    saver: (data: T) => Promise<void>,
    onSuccess?: (data: T) => void
) {
    const [saving, setSaving] = useState(false);
    const [saveError, setSaveError] = useState<string | null>(null);
    const [saveComplete, setSaveComplete] = useState(false);

    const save = useCallback(async (data: T) => {
        setSaving(true);
        setSaveError(null);
        setSaveComplete(false);

        try {
            await saver(data);
            onSuccess?.(data);
            setSaveComplete(true);
        } catch (err) {
            setSaveError(`Failed to save resource ${err}`);
        } finally {
            setSaving(false);
        }
    }, [saver, onSuccess]);

    return { saving, saveError, saveComplete, save };
}
